const forOwn = require('mout/object/forOwn')

export default function getTrueProps(obj) {
  let output = []
  forOwn(obj, (val, key, o) => {
    if (val === true) {
      output.push(key)
    }
  })
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/getTrueProps.js